import experiment from 'experiment';

const isSiteBranchesActive = () =>
  experiment.isOpen('specs.corvid.SiteBranchesSidebar');

const isNewVeloWorkspace = () =>
  experiment.isOpen('specs.wixCode.se_veloComponentsNewWorkspace');

export { isSiteBranchesActive, isNewVeloWorkspace };
